import { render } from "./LoginRecordsTable.vue?vue&type=template&id=69bfa72b&scoped=true"
import script from "./LoginRecordsTable.vue?vue&type=script&lang=js"
export * from "./LoginRecordsTable.vue?vue&type=script&lang=js"

import "./LoginRecordsTable.vue?vue&type=style&index=0&id=69bfa72b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69bfa72b"]])

export default __exports__